export default "__VITE_ASSET__CCOBDyb9__"